import logo_confirmation from '../../public/image/icon-check-confirmation.png';

function ConfirmationPage() {
    return (
        <div className="conteneur">
            <div className="texte centered">
                <img className="logo_confirmation" src={logo_confirmation} alt="icone de confirmation"/>
                <br/>
                <h5><b>Votre demande a bien été prise en compte !</b></h5>
                <span>Les équipes Macif Assistance reviendront vers vous par mail, dans les plus brefs délais.</span>
            </div>
        </div>
    );
}

export default ConfirmationPage;